import React from 'react';
import Image from 'next/image';
import clsx from 'clsx';

import { ManualCouponButton } from '~/components/checkout/CreditsCoupons';
import Chevron from '~/public/font-awesome/chevron-down-bolt.png';

interface CouponControlsProps {
  couponSize: number;
  isToggleMore: boolean;
  showManualCoupon: boolean;
  toggleManualCoupon: () => void;
  toggleMore: () => void;
}

export default React.memo(function CouponControls({
  couponSize,
  isToggleMore,
  showManualCoupon,
  toggleManualCoupon,
  toggleMore,
}: Readonly<CouponControlsProps>): React.ReactElement {
  const iconClassName = clsx(
    'mr-1 transition duration-100 ease-in-out',
    isToggleMore && 'rotate-180',
  );

  if (!couponSize) return <></>;

  return (
    <div className="-mt-2 flex justify-between">
      {!showManualCoupon ? (
        <ManualCouponButton
          onClick={toggleManualCoupon}
          label="Use a different discount code"
        />
      ) : (
        <div />
      )}
      {couponSize > 2 ? (
        <button
          className="flex items-center text-center text-sm text-bolt hover:underline md:mr-0 md:mt-0"
          onClick={toggleMore}
        >
          <Image
            height={16}
            width={16}
            src={Chevron}
            alt="chevron"
            className={iconClassName}
          />
          {isToggleMore ? 'Hide' : `View more (${couponSize - 2})`}
        </button>
      ) : (
        <div />
      )}
    </div>
  );
});
